import { useState } from "react";
import AdminUserView from "../AdminUserView/AdminUserView";
import AdminStoresView from "../AdminStoresView/AdminStoresView";
import "./AdminView.css";

const AdminView: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'users' | 'stores'>('users');

    return (
        <div id="Admin-View" className="admin-dashboard">
          
            <div className="admin-tabs">
                <button 
                    className={`tab-button ${activeTab === 'users' ? 'active' : ''}`}
                    onClick={() => setActiveTab('users')}
                >
                    Utilisateurs
                </button>
                <button 
                    className={`tab-button ${activeTab === 'stores' ? 'active' : ''}`}
                    onClick={() => setActiveTab('stores')}
                >
                    Magasins
                </button>
            </div>
            
            <div className="tab-content">
                {activeTab === 'users' && 
                    <AdminUserView />
                }
                {activeTab === 'stores' && 
                    <AdminStoresView />
                }
            </div>
        </div>
    );
};

export default AdminView;
